// extracted by mini-css-extract-plugin
module.exports = {"label":"kSRif","flag":"hk0oA","text":"l0X3G"};